// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type { AppOptions, EnvironmentType } from '@seedplanner/shared-utils';
import type { AppContextType } from '@seedplanner/shared-web';

export const createAppContext = ({
  environment,
  css,
  nonce,
  options,
  userAgent,
}: {
  readonly environment: EnvironmentType;
  readonly css: ReadonlyArray<string>;
  readonly nonce: string | undefined;
  readonly options: AppOptions;
  readonly userAgent: UAParser.IResult;
}): AppContextType => {
  return {
    css,
    nonce,
    options,
    userAgent,
    environment,
  };
};
